const zh = {
  salePrice: '销售价',
  maPrice: '物料总价',
  finallyPrice: '利润',
  purePrice: '净利润',
  priceCheck: '成本核算',

  save: '保存',
  saveSuccess: '核算数据已更新',
  saveError: '核算数据更新失败',
  saveTip: '确认保存',
  saveTipContent: '是否保存修改的优惠/折扣和佣金比例？',
  costUpdate: '成本核算数据有更改',
  costUpdateTip: '确定放弃更改么？'
}

export default zh